import React from 'react';
import type { Conversation } from '../services/api';

function formatTime(iso: string): string {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  const diff = Date.now() - t;
  if (isNaN(t)) return '';
  if (diff < 60_000) return '刚刚';
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)} 分钟前`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)} 小时前`;
  if (diff < 7 * 86_400_000) return `${Math.floor(diff / 86_400_000)} 天前`;
  return new Date(t).toLocaleDateString('zh-CN', { month: 'numeric', day: 'numeric' });
}

interface Props {
  conversations: Conversation[];
  activeId: number | null;
  onSelect: (id: number | null) => void;
  onCreate: () => void;
  onDelete: (id: number) => void;
  onTogglePin: (id: number) => void;
}

export default function ConversationSidebar({ conversations, activeId, onSelect, onCreate, onDelete, onTogglePin }: Props) {
  return (
    <aside className="conv-sidebar">
      <div className="conv-sidebar-header">
        <button className="conv-new-btn" onClick={onCreate}>
          <span>＋</span> 新对话
        </button>
      </div>

      <div className="conv-list flex-1 overflow-y-auto">
        {conversations.length === 0 ? (
          <div className="conv-empty">
            还没有对话记录
            <br />
            点击「新对话」开始提问
          </div>
        ) : (
          conversations.map(conv => (
            <div
              key={conv.id}
              className={`conv-item ${activeId === conv.id ? 'active' : ''} ${conv.pinned ? 'pinned' : ''}`}
              onClick={() => onSelect(conv.id)}
            >
              <span className="conv-item-icon">{conv.pinned ? '📌' : '💬'}</span>
              <span className="conv-item-main">
                <span className="conv-item-title">{conv.title || '新对话'}</span>
                <span className="conv-item-time">{formatTime(conv.updated_at)}</span>
              </span>
              <button
                type="button"
                className={`conv-item-pin ${conv.pinned ? 'pinned' : ''}`}
                title={conv.pinned ? '取消置顶' : '置顶'}
                onClick={(e) => {
                  e.stopPropagation();
                  onTogglePin(conv.id);
                }}
              >
                📌
              </button>
              <button
                className="conv-item-delete"
                title="删除对话"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm('确定删除这个对话？')) onDelete(conv.id);
                }}
              >
                ✕
              </button>
            </div>
          ))
        )}
      </div>

      <div className="conv-sidebar-footer">
        <span className="status-dot online" />
        共 {conversations.length} 个对话
      </div>
    </aside>
  );
}
